import { useState, useEffect } from 'react'
import { ReportsApprovalTypes } from '../types/ReportsApproval'
import { getApprovalSchedulersList } from '../api/api'

export function useReportsApproval(): [ReportsApprovalTypes[]] {
    const [reportsApproval, setReportsApproval] = useState<ReportsApprovalTypes[]>([])

    function getReportsApproval() {
        getApprovalSchedulersList().then(response => {
            response.length > 0 && setReportsApproval(response)
        })
    }

    useEffect(() => {
        let intervalId

        getReportsApproval()

        setInterval(() => {
            intervalId = getReportsApproval()
        }, 5000)

        return () => {
            clearInterval(intervalId)
        }
    }, [])

    return [reportsApproval]
}
